<template>
	<b-container class="show-document" style="width:1000px">
		<div class="actions mb-2 mt-2 hidden-print">
			<div class="pull-left">
				<b-button @click="goBackToFrom" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{ $t('back')
					}}
				</b-button>
			</div>
			<div class="pull-right">
				<!-- <b-button
					variant="outline-dark"
					@click="editAvizModal"
					class="mr-2"
				>
					<i class="fa fa-edit"></i>
					{{$t('kochirish.edit')}}
				</b-button> -->
				<!-- <b-button
					variant="outline-primary"
					@click="excelExport('whDocTable', item.regNumber)"
					class="mr-2"
				> -->
					<!-- {{ $t('excel-export.download-excel') }}
				</b-button> -->
				<b-button
					variant="outline-dark"
					@click="print"
					class="mr-2"
				>
					<i class="fa fa-print"></i>
					{{$t('pricing.print')}}
				</b-button>

			</div>
			<div class="clearfix"></div>

		</div>
		<div class="doc-body">
			<b-card class="pl-5 pr-5 pt-4 pb-4" style="min-height:29.7cm; min-width:21cm !important;" >
                <b-row>
                    <b-col cols="8"></b-col>
                    <b-col cols="4" style="font-size:10px;">
                         <div class="float-right" style="text-align:right;">
                             <b>
                            <p> Formular tipizat</p>
                            <p><i> Anexa nr.1 <br>
                            la Ordinul Ministerului Finanţelor <br>
                            al Republicii Moldova <br>
                            nr. 65 din 18 aprilie 2019</i></p></b>
                           
                            <p>
                                Типовая форма 
                            </p>
                            <p>
                                <i>Приложение № 1
                                    <br>
                                    к Приказу Министерства финансов <br>
                                    Республики Молдова <br>
                                    № 65 от 18 апреля 2019 г.
                                </i>
                            </p>
                         </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" style="font-size:13px;">
                           <div class="doc" style="border:0.5px solid black;min-height:29.7cm">
                                <div class="doc-header">
                                    <div class="text-center">
                                         <b><p>Aviz de însoțire a mărfii   </p></b>
                                         <p>Товарно-сопроводительное уведомление</p>
                                    </div>
                                    <b-row class="ml-2 mt-1">
                                        <div class="pl-1">
                                        <span><b>Seria</b></span> 
                                        <span style="border-bottom:1px solid black; width:120px; display:inline-block"></span><br>
                                            <span>Cерия </span>
                                        </div>
                                        <div class="pl-1">
                                            <span><b>nr.</b></span> 
                                            <span style="border-bottom:1px solid black; width:120px; display:inline-block"></span><br>
                                            <span>№</span>
                                        </div>
                                        <div class="pl-1">
                                            <span><b>data </b></span> 
                                            <span style="border-bottom:1px solid black; width:120px; display:inline-block"></span><br>
                                            <span>дата</span>
                                        </div>
                                    </b-row>

                                    <b-row class="mt-5 ml-0 mr-0"
                                    style="border-top:0.5px solid black">
                                        <b-col cols="8" class="p-2">
                                             <div class="pl-1">
                                            <span><b>1. Furnizor:</b></span> 
                                            <span style="border-bottom:1px solid black; width:300px; display:inline-block"></span><br>
                                            <span>Поставщик</span>
                                        </div>
                                        </b-col>
                                        <b-col class="p-2" cols="4" style="border-left:1px solid black;">
                                            <div class="pl-1">
                                            <span><b>c.f./ nr.TVA</b></span> 
                                            <span style="border-bottom:1px solid black; width:130px; display:inline-block"></span><br>
                                            <span>ф.к./ код НДС</span>
                                            </div>
                                        </b-col>
                                    </b-row>

                                    <b-row class="mt-0 ml-0 mr-0"
                                    style="border-top:0.5px solid black">
                                        <b-col cols="8" class="p-2">
                                             <div class="pl-1">
                                            <span><b>2. Cumpărător/beneficiar:</b></span> 
                                            <span style="border-bottom:1px solid black; width:200px; display:inline-block"></span><br>
                                            <span>Покупатель/получатель</span>
                                        </div>
                                        </b-col>
                                        <b-col cols="4" class="p-2" style="border-left:1px solid black;">
                                            <div class="pl-1">
                                            <span><b>c.f./ nr.TVA</b></span> 
                                            <span style="border-bottom:1px solid black; width:130px; display:inline-block"></span><br>
                                            <span>ф.к./ код НДС</span>
                                            </div>
                                        </b-col>
                                    </b-row>


                                    <b-row class="mt-0 ml-0 mr-0"
                                    style="border-top:0.5px solid black">
                                        <b-col cols="8" class="p-2">
                                             <div class="pl-1">
                                            <span><b>3. Transportator</b></span> 
                                            <br>
                                            <span>Перевозчик </span>
                                        </div>
                                        </b-col>
                                        <b-col cols="4" class="p-2" style="border-left:1px solid black;">
                                            <div class="pl-1">
                                            <span><b>c.f./ nr.TVA</b></span> 
                                            <span style="border-bottom:1px solid black; width:130px; display:inline-block"></span><br>
                                            <span>ф.к./ код НДС</span>
                                            </div>
                                        </b-col>
                                    </b-row>


                                    <b-row class="mt-0 ml-0 mr-0"
                                    style="border-top:0.5px solid black">
                                        <b-col cols="5" class="p-2">
                                             <div class="pl-1">
                                            <span><b>4. Nr. de înmatriculare a <br>
                                             mijlocului de transport</b></span> 
                                            <br>
                                            <span>Номерной знак транспортного средство</span>
                                        </div>
                                        </b-col>
                                         <b-col cols="3" class="p-2" style="border-left:1px solid black;">
                                             <div class="pl-1">
                                            <span><b>Remorca (semiremorca)<br>
                                             mijlocului de transport</b></span> 
                                            <br>
                                            <span>прицеп (полуприцеп)</span>
                                        </div>
                                        </b-col>
                                         <b-col  cols="4" class="p-2" style="border-left:1px solid black;">
                                             <div class="pl-1">
                                            <span><b>7. Foaia de parcurs 
                                            </b>Seria, nr. data</span> 
                                            <br>
                                            <span>Путевой лист   Серия,  №    дата</span>
                                        </div>
                                        </b-col>
                                    </b-row>


                                     <b-row class="mt-0 ml-0 mr-0"
                                    style="border-top:0.5px solid black; border-bottom:0.5px solid black">
                                        <b-col cols="8" class="p-2">
                                             <div class="pl-1">
                                            <span><b>5. Punct încărcare</b></span> 
                                            <span style="border-bottom:1px solid black; width:180px; display:inline-block"></span><br>
                                            <span>Пункт погрузки</span>
                                        </div>
                                        </b-col>
                                        <b-col cols="4" class="p-2" style="border-left:1px solid black;">
                                            <div class="pl-1">
                                            <span><b>6. Punct descărcare</b></span> 
                                            <span style="border-bottom:1px solid black; width:100px; display:inline-block"></span><br>
                                            <span>Пункт разгрузки</span>
                                            </div>
                                        </b-col>
                                    </b-row>


                                    <b-row class="mt-1 ml-0 p"  > 
                                        <table class="table">
                                        <tr class="bg-light">
                                            <th class="text-center p-2">
                                                8.1
                                                Nr.
                                                crt.
                                                №
                                            </th>
                                            <th class="text-center p-2">
                                                8.2
                                                Denumirea mărfurilor 
                                                Наименование товаров
                                            </th>
                                            <th class="text-center p-2">
                                                 8.3
                                                Etalon cantitativ
                                                Единица
                                                изме-
                                                рения</th>
                                            <th class="text-center p-2">
                                                8.4
                                                Cantitatea
                                                mărfurilor
                                                Количество
                                                товаров
                                            </th>
                                            <th class="text-center p-2">
                                               8.5
                                                Preţ
                                                unitar,
                                                lei
                                                Цена
                                                еди-
                                                ницы,
                                                леев
                                            </th>
                                            <th class="text-center p-2">
                                               8.6
                                                Valoa-
                                                rea,
                                                lei
                                                Стои-
                                                мость,
                                                леев
                                            </th>
                                            <th class="text-center p-2">
                                                8.7
                                                Cantitatea mărfurilor primite
                                                Количество полученных товаров
                                            </th>
                                            <th class="text-center p-3">
                                                8.8
                                                Cantitatea mărfurilor neacceptate 
                                                Количество непринятых товаров
                                            </th>
                                        </tr>

                                        <tr>
                                            <th class="text-center" colspan="6">9. TOTAL</th>
                                            <th class="text-center" colspan="2">X </th>
                                        </tr>
                                    </table>
                                    </b-row>

                                    <b-row class="mt-1 ml-0 mr-0">
                                        <div  class="pl-2 pt-1 pb-1 pr-2">
                                            <span><b>10. Permis eliberarea: </b></span> <br>
                                            <span class="ml-3">Отпуск разрешил:</span>
                                            <span  style="margin-left:100px;border-bottom:1px solid black; width:500px; display:inline-block"></span>
                                            <div class="float-right text-right">
                                                <b><p> Funcţia, numele, prenumele şi semnătura</p></b>
                                                <p> Должность, фамилия, имя и подпись</p>
                                            </div>
                                        </div>

                                          <div class="pl-2 pt-1 pb-1 pr-2">
                                            <span><b>11. Predat mărfurile:</b></span> <br>
                                            <span class="ml-3">Сдал товары: </span>
                                            <span  style="margin-left:130px;border-bottom:1px solid black; width:500px; display:inline-block"></span>
                                            <div class="float-right text-right">
                                                <b><p> Funcţia, numele, prenumele şi semnătura</p></b>
                                                <p> Должность, фамилия, имя и подпись</p>
                                            </div>
                                        </div>

                                        <div class="pl-2 pt-1 pb-1 pr-2">
                                            <span><b>12. Primit mărfurile intermediarul (transportatorul):</b></span> <br>
                                            <span class="ml-3">Принял товары посредник (перевозчик):   </span>
                                            <span  style="margin-left:50px;border-bottom:1px solid black; width:400px; display:inline-block"></span>
                                            <div class="float-right text-right">
                                                <b><p> Funcţia, numele, prenumele şi semnătura</p></b>
                                                <p> Должность, фамилия, имя и подпись</p>
                                            </div>
                                        </div>

                                        <div class="pl-2 pt-1 pb-1 pr-2">
                                            <span><b>13. Predat mărfurile intermediarul (transportatorul):</b></span> <br>
                                            <span class="ml-3">Сдал товары посредник (перевозчик):     </span>
                                            <span  style="margin-left:80px;border-bottom:1px solid black; width:400px; display:inline-block"></span>
                                            <div class="float-right text-right">
                                                <b><p> Funcţia, numele, prenumele şi semnătura</p></b>
                                                <p> Должность, фамилия, имя и подпись</p>
                                            </div>
                                        </div>

                                         <div class="pl-2 pt-1 pb-1 pr-2">
                                            <span><b>14. Primit mărfurile cumpărătorul/beneficiarul:</b></span> <br>
                                            <span class="ml-3"> Принял товары покупатель/получатель:  </span>
                                            <span  style="margin-left:60px;border-bottom:1px solid black; width:400px; display:inline-block"></span>
                                            <div class="float-right text-right">
                                                <b><p> Funcţia, numele, prenumele şi semnătura</p></b>
                                                <p> Должность, фамилия, имя и подпись</p>
                                            </div>
                                        </div>

                                         <div class="pl-2 pt-1 pb-1 pr-2">
                                            <span><b>15. Predat mărfurile neacceptate</b></span> <br>
                                            <span class="ml-3"> Сдал непринятые товары      </span>
                                            <span  style="margin-left:150px;border-bottom:1px solid black; width:400px; display:inline-block"></span>
                                            <div class="float-right text-right">
                                                <b><p> Funcţia, numele, prenumele şi semnătura</p></b>
                                                <p> Должность, фамилия, имя и подпись</p>
                                            </div>
                                        </div>

                                    </b-row>
                                </div>
                            </div>
                    </b-col>
                </b-row>
			</b-card>
		</div>
	</b-container>
</template>

<script>
	import {mapActions, mapState} from 'vuex';
	import WhDocument from "../../../../services/wh-document.service";
	import Multiselect from 'vue-multiselect'
	import moment from 'moment'
	import UsersService from "../../../../services/users.sevice"; 
	import EmployeeSerive from "../../../../services/employees.service"
	import CreateForm from "../blocks/CreateForm";

	export default {
		name: 'Show',

		data() {
			return {
				regNumber:null,
				vatPercentage: null,
				name: null,
				aviz:null,
				regNumberAviz: null,
				docId: null,
				value: null,
        		options: [],
				modalAviz: false,
				loader: false,
				item: {},
				totalPrice: {
					uzs: 0,
					usd: 0,
					saleTypePrice: 0,
				},
				priceType: 'uzs',
				income: [],
				totalIncome: {
					uzs: 0,
					usd: 0
				},
				confirmBarcodeGenerate: false,
				barcodeCount: 0,
				currentWhItems: [],
				sidebar: {
					open: false,
					close: false
				},
				backTo: null,
			}
		},

		methods: {
			getDepartmentInfo() {
				if (this.$can('get', 'warehouse-document')) {
				this.loader = true;
				return WhDocument.getDeparmentForDocument(this.item.fromDepartmentId).then(res => {
					this.loader = false;
					this.vatPercentage = res.data.vatPercentage
					this.item.fromAddress = res.data.address
					this.item.fromBankAccount = res.data.bankAccount
					this.item.toAddress = res.data.address
					this.item.toBankAccount = res.data.bankAccount
					// this.item = response.data;
					// this.sumPrice(this.item);
					// this.sumIncome(this.item);
				}).catch(error => {
					this.loader = false
				})
				}
			},
			async editAvizDocForUser() {
				try{
					let payload = {
						whDocumentId: this.item.id,
						responsibleId: this.value.id,
						regNumber: this.regNumberAviz,
						initialLetter: this.name
					}
					if(this.value) {
						let res = await EmployeeSerive.editAviz(this.aviz.id, payload)
						if(res.data) {
						await this.get()
						await this.getDepartmentInfo()
						await this.getAviz()
						this.modalAviz = false;
					}
					}
				}catch (e) {
					if(e.request.response) {
						let res = JSON.parse(e.request.response)
						this.$vs.notify({
							title: this.$t('words.error'),
							text: res.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						})
					}
				}
			},
			userSelectedOption (user) {
				return user.firstName + ' ' + user.lastName ;
			},
			async editAvizModal() {
				// this.regNumberAviz = null;
				// this.value = null
				this.modalAviz = true
			},
			...mapActions('warehouse', [
				'setFromIncomeToTransfer', 'setCurrentWhItems'
            ]),
            calculateRealCostOfItem(item) {
				/*let sumOfPriceWithoutNds = (item.priceWholesale/1.2) * item.count;
                let sumOfNds = ((item.priceWholesale * item.count) * 0.2)/1.2;*/
				if (item.priceUzs > 0) {
					return item.priceUzs* item.count;
				} else {
					return 0
				}
			},
			calculateNdsOfItem(item) {
				return this.calculateRealCostOfItem(item) / 6;
			},
			calculateSumOfItemWithoutNds(item) {
				return this.calculateRealCostOfItem(item) - this.calculateNdsOfItem(item);
			},
			calculatePriceWithoutNds(item) {
				return this.calculateSumOfItemWithoutNds(item) / item.count;
			},
			calculateTotalRealCost() {
				let temp = 0;
				if(this.item.whItems) {
                for (let i = 0; i < this.item.whItems.length; i++) {
                            temp += this.calculateRealCostOfItem(this.item.whItems[i]);
                        }
                  }
				return temp;
			},
			updateWeight(item) {
				if (item.sumWeightAllItems > 1000) {
					return item.sumWeightAllItems / 1000 + ' кг';
				}
				if (item.sumWeightAllItems < 1000) {
					return item.sumWeightAllItems + ' гр';
				}
				if (item.sumWeightAllItems > 1000000) {
					return item.sumWeightAllItems / 1000000 + ' тонна';
				}
			},
			async getAviz() {
				if (this.$can('get', 'warehouse-document')) {
					this.loader = true;
					let res = await EmployeeSerive.getEmployeeIfHaveLogin(this.item.toDepartmentId)
					this.options = res.data
					return EmployeeSerive.hasAvizDocument(this.$route.params.id).then(response => {
						this.aviz = response.data;
						this.name  = response.data.initialLetter
						this.regNumber = response.data.regNumber
						if(response.data.regNumber <= 9) {
						this.regNumber = '000'+response.data.regNumber
						}else if(response.data.regNumber <= 99 && response.data.regNumber > 9){
							this.regNumber= '00'+response.data.regNumber
						}else {
							this.regNumber = '0'+response.data.regNumber
						}
						this.options.forEach(el => {
							if(el.id == response.data.responsibleId) {
								this.value = el
							}
						})
						this.loader = false;
					}).catch(error => {
						this.loader = false
					})
				}
			},
			get() {
				if (this.$can('get', 'warehouse-document')) {
					this.loader = true;
					return WhDocument.get(this.$route.params.id).then(response => {
						this.loader = false;
						this.item = response.data;
						this.sumPrice(this.item);
						this.sumIncome(this.item);
					}).catch(error => {
						this.loader = false
					})
				}
			},
			sumPrice(item) {
				if (typeof item.whItems === 'object') {
					Object.values(item.whItems).map(item => {
						if (item.priceUsd) this.totalPrice.usd += item.priceUsd * item.count;
						if (item.priceUzs) this.totalPrice.uzs += item.priceUzs ? item.priceUzs * item.count : 0;
						if (item.saleTypePrice) this.totalPrice.saleTypePrice += item.saleTypePrice ? item.saleTypePrice * item.count : 0;
					});
				}
			},
			sumIncome(item) {
				if (typeof item.whItems === 'object') {
					Object.values(item.whItems).map(item => {
						this.totalIncome.usd += item.incomingPriceUsd * item.count;
						this.totalIncome.uzs += item.incomingPriceUzs ? item.incomingPriceUzs * item.count : 0;
					});
				}
			},
			formatDate(date, format = 'DD-MM-YYYY') {
				if (date) {
					const split = date.split(' ');
					date = split[0];
					const revers = date.split('-');
					date = revers[2] + '-' + revers[1] + '-' + revers[0] + 'T00:00:00';
					return moment(String(date)).format(format)
				}
			},
			goBackToFrom() {
				this.$router.back();
			},
			print() {
				window.print();
			},
			openSidebar() {
				setTimeout(() => {
					this.sidebar.open = true
				}, 200)
			},

			generateBarcode() {
				//this.currentWhItems = Object.assign({}, this.item.whItems);
				this.currentWhItems = JSON.parse(JSON.stringify(this.item.whItems));
				this.confirmBarcodeGenerate = true;
				//this.$router.push(`/warehouse-management/income/barcodes/${this.$route.params.id}`);

			},
			cancelBarcodeGenerate() {
				this.confirmBarcodeGenerate = false;
			},
			submitBarcodeGenerate() {
				let items = {};
				items.status = true;
				items.data = this.currentWhItems.filter(column => column.checked === true);
				items.data.forEach((item, index) => {
					items.data[index].count = parseInt(item.count)
				});
				this.setCurrentWhItems(items);
				this.$router.push(`/warehouse-management/income/barcodes`);
			},

			remove() {
				WhDocument.remove(this.item.id).then(response => {
					this.$router.push('/warehouse-management/income');
				})
			},

			showConfirm(item) {
				let refName = 'popover' + item;
				this.$refs[refName].$emit('open')
			},
			closeConfirm(item) {
				let refName = 'popover' + item;
				this.$refs[refName].$emit('close')
			},
			excelExport(table, fileName = '') {


				var uri = 'data:application/vnd.ms-excel;base64,'
					,
					template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
					, base64 = function (s) {
						return window.btoa(unescape(encodeURIComponent(s)))
					}
					, format = function (s, c) {
						return s.replace(/{(\w+)}/g, function (m, p) {
							return c[p];
						})
					}
					, downloadURI = function (uri, name) {
						var link = document.createElement("a");
						link.download = name;
						link.href = uri;
						link.click();
					}

				if (!table.nodeType) table = document.getElementById(table)
				var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
				var resuri = uri + base64(format(template, ctx))
				downloadURI(resuri, fileName);
			},


		},
		async created() {
			await this.get();
			await this.getDepartmentInfo()
			await this.getAviz();
		},
		computed: {
			calculateAllTotalPrice(){
				let temp = 0
				this.item.whItems.forEach(el=> {
					temp += this.calculatePriceWithoutNds(el) * el.count
				})
				return temp
			},
			calculateAllTotalNds() {
				let temp = 0
				this.item.whItems.forEach(el=> {
					temp += (el.priceUzs - this.calculatePriceWithoutNds(el)) * el.count
				})
				return temp
			},
			/*incomeField() {
				return this.income[0]
			},*/
			totalCount() {
				let sum = 0;
				if (this.item.whItems) {
					if (this.item.whItems.length > 0) {
						this.item.whItems.forEach(el => {
							sum += el.count;
						});
					}
				}
				return sum;
			}
		},
		components: {
			CreateForm,
			Multiselect
		},
		watch: {
			value: {
				async handler(newVal) {
					if(newVal) {
						if(newVal.id == this.aviz.responsibleId) {
							this.regNumberAviz = this.regNumber
						}else {
							let res = await EmployeeSerive.getRegNumber(newVal.id)
							if(res.data <= 9) {
								this.regNumberAviz = '000'+res.data
							}else if(res.data <= 99 && res.data > 9){
								this.regNumberAviz = '00'+res.data
							}else {
								this.regNumberAviz = '0'+res.data
							}
							this.name = newVal.firstName.charAt(0)
							}
					}
				}
			}
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
  
    p {
        margin: 0
    }
    .p {
        margin-right: -0.8px;
    }
    .doc {
        z-index: 999;
    }
    .table {
        margin-left:-0.5px !important;
       tr {
           th {
               border:0.5px solid black
           }
           td {
                th {
               border:0.5px solid black
           }
           }
       }
    }
	@media print {
        .p {
            margin-right: -0.8px;
        }
        .table {
            width: inherit !important;
        // margin-right:-0.89px !important;
        tr {
           th {
               border:0.5px solid black
           }
           td {
                th {
               border:0.5px solid black
           }
           }
       }
    }
    	.hidden-print {
			display: none;
		} 
		.card {
			box-shadow: none;
        }
	}

	.spinner-wrapper {
		position: absolute;
		background: rgba(32, 28, 32, 0.49);
		left: 0;
		right: 0;
		text-align: center;
		top: 0;
		bottom: 0;
		padding-top: 35px;
		z-index: 5;
	}
</style>
